// extracted by mini-css-extract-plugin
module.exports = {"root":"player-level_root__1Ex0M","level":"player-level_level__2fhkg"};